export const MAX_TIMER_DURATION_MINUTES = 1440;
//# sourceMappingURL=time-entry.js.map